import { render, staticRenderFns } from "./CreateJudge.vue?vue&type=template&id=cefad00a&scoped=true"
import script from "./CreateJudge.vue?vue&type=script&lang=js"
export * from "./CreateJudge.vue?vue&type=script&lang=js"
import style0 from "./CreateJudge.vue?vue&type=style&index=0&id=cefad00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefad00a",
  null
  
)

export default component.exports